export const PRODUCT_CONCIERGE = 'concierge';
export const PRODUCT_GUARANTEED_HIRE = 'guaranteed-hire';
export const PRODUCT_PREMIUM_PLUS = 'premium-plus';
